import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';
import { DateIcon } from '../Icon';
import { classNames, initValue } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    background: '#fff',
    flexGrow: '1',
    '& .MuiInput-root': {
      height: '3.5rem',
    },
    '& .MuiInput-underline:before': {
      borderBottom: '0',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '0',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.875rem',
      color: '#2e4469',
      paddingLeft: '1.25rem',
    },
    '& .MuiIconButton-root': {
      padding: '0.75rem',
      marginRight: '0.5rem',
    },
  },
  dateIcon: {
    width: '1.125rem',
    height: '1.25rem',
    color: '#5f9df6',
  },
}));

export default function BorderDatePicker(props) {
  const { className, value } = props;
  const classes = useStyles();
  return (
    <KeyboardDatePicker
      {...props}
      className={className.root ? classNames(classes.root, className.root) : classes.root}
      variant="inline"
      ampm={false}
      value={initValue(value, new Date())}
      onError={console.log}
      disablePast
      format="D/MM/yyyy"
      keyboardIcon={
        <DateIcon className={className.icon ? classNames(classes.dateIcon, className.icon) : classes.dateIcon} />
      }
    />
  );
}
